<!-- Section header (desktop) -->
<div class="d-none d-md-flex align-items-center gap-2 mb-2 mt-4">
  <h6 class="fw-bold text-body-secondary mb-0">💧 {{ 'ZISTERNE_TITLE' | translate }}</h6>
  <span *ngIf="zisterneUpdatedAt" class="text-muted small">{{ updatedAgo(zisterneUpdatedAt) }}</span>
  <span *ngIf="liveDotOn && zisterneUpdatedAt" class="live-dot ms-1"></span>
</div>

<!-- Expanded chart template -->
<ng-template #levelExpandedTpl>
  <div class="d-flex align-items-center gap-2 mb-1">
    <span class="fw-semibold small">💧 {{ 'ZISTERNE_TITLE' | translate }}</span>
    <div class="btn-group btn-group-sm ms-auto" role="group">
      <button *ngFor="let r of chartRanges" class="btn"
              [ngClass]="range === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
              (click)="setRange(r.key)">{{ r.label }}</button>
    </div>
    <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted" role="status"></span>
  </div>
  <div style="aspect-ratio:16/9;">
    <canvas baseChart [data]="levelExpandedData" [options]="levelExpandedOptions" type="line"></canvas>
  </div>
</ng-template>

<div class="row g-2 g-sm-3 mb-3" *ngIf="zisterne" [class.section-flash]="zisterneFlash">

  <!-- Füllstand -->
  <div class="col-6 col-lg-3">
    <app-popup-card cardClass="h-100" popupMaxWidth="min(92vw, 1100px)"
                    [tapTpl]="zisterneHistory.length >= 2 ? levelExpandedTpl : undefined">
      <ng-template #body>
        <div class="card-body d-flex flex-column p-2 p-sm-3">
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <div class="card-icon fs-2 flex-shrink-0">💧</div>
            <div class="min-w-0 flex-grow-1">
              <div class="text-muted small">{{ 'ZISTERNE_TITLE' | translate }}</div>
              <div class="card-value fs-5 fw-bold text-truncate"
                   [class.text-primary]="zisterne.levelPct >= 50"
                   [class.text-warning]="zisterne.levelPct >= 20 && zisterne.levelPct < 50"
                   [class.text-danger]="zisterne.levelPct < 20">
                {{ zisterne.levelPct | number:'1.0-0' }}%
              </div>
              <div class="progress mt-1" style="height:5px;">
                <div class="progress-bar"
                     [class.bg-primary]="zisterne.levelPct >= 50"
                     [class.bg-warning]="zisterne.levelPct >= 20 && zisterne.levelPct < 50"
                     [class.bg-danger]="zisterne.levelPct < 20"
                     [style.width.%]="zisterne.levelPct"></div>
              </div>
              <div *ngIf="zisterne.battery >= 0" class="text-muted" style="font-size:.68rem;">
                🔋 {{ zisterne.battery }}%
              </div>
            </div>
          </div>
          <div *ngIf="zisterneHistory.length >= 2" style="height:90px;margin-top:6px;">
            <canvas baseChart [data]="levelChartData" [options]="levelChartOptions" type="line"></canvas>
          </div>
        </div>
      </ng-template>
    </app-popup-card>
  </div>

</div>

<!-- Skeleton loader -->
<div *ngIf="!zisterne" class="row g-2 g-sm-3 mb-3">
  <div class="col-6 col-lg-3">
    <div class="card h-100">
      <div class="card-body p-3">
        <div class="placeholder-glow">
          <span class="placeholder col-6"></span>
          <span class="placeholder col-8 mt-2"></span>
        </div>
      </div>
    </div>
  </div>
</div>
